module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"address-label-templates":"Address Label Templates","template-deleted":"Template deleted","failed-delete-template":"Failed to delete template","owner":"Owner","duplicate":"Duplicate"}}')
  delete Component.options._Ctor
}
